<!--
    Instead of maintainting a dependency on vue-instantsearch (which changes more often than it should),
    this is a super quick reimplementation of just the bit we actually used.

-->
<template>
    <a v-if="url" class="search-result__link" :href="hit.recipients[0].url">
        <span v-if="this.hit._highlightResult" v-html="html"></span>
    </a>
    <span v-else="this.hit._highlightResult" v-html="html"></span>
</template>

<script>
export default {
    props: {
        hit: Object,
        attribute: String,
        url: Boolean
    },
    computed: {
        html() {
            const path = this.attribute.split('.');

            // Since Algolia's own library depends on it, `_highlightResult` should be pretty safe to access.
            let source = this.hit._highlightResult;

            while (path.length > 0) {
                source = source[path.shift()];
            }

            if (source && source.value) {
                return source.value;
            } else {
                return null;
            }
        }
    }
};
</script>

<!--Not scoped, since content is provided by `v-html`.-->
<style>
.algolia-search-highlight {
    background: #f8ea58;
    font-style: normal;
    margin: 0 -0.2ch;
    padding: 0 0.2ch;
}
</style>
